enum SocialProvider {
  GOOGLE = "GOOGLE",
  APPLE = "APPLE",
  FACEBOOK = "FACEBOOK",
  WHATSAPP = "WHATSAPP",
}

export default SocialProvider;
